import { render } from "./record-payment.vue?vue&type=template&id=df2f9f20&scoped=true"
import script from "./record-payment.vue?vue&type=script&lang=js"
export * from "./record-payment.vue?vue&type=script&lang=js"

import "./record-payment.vue?vue&type=style&index=0&id=df2f9f20&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df2f9f20"]])

export default __exports__